import { NEW_LANGUAGE_VOICE } from "./new-voice";

export const breakDetails = [
  { name: "Default", value: "default" },
  { name: "X-Weak", value: "x-weak" },
  { name: "Weak", value: "weak" },
  { name: "Medium", value: "medium" },
  { name: "Strong", value: "strong" },
  { name: "X-Strong", value: "x-strong" },
];

export const GENDERS = [
  // { name: "Both", value: "both" },
  { name: "Male", value: "male" },
  { name: "Female", value: "female" },
];

export const LANGUAGE_DATA = [
  ...new Map(
    NEW_LANGUAGE_VOICE.map((field) => {
      return {
        ...field,
        value: field.id.slice(0, 5),
      };
    }).map((item) => [item["value"], item])
  ).values(),
] || [
  { name: "Afrikaans (South Africa)", value: "af-ZA", dataValue: "afZAData" },
  { name: "Albanian (Albania)", value: "sq-AL", dataValue: "sqALData" },
  { name: "Amharic (Ethiopia)", value: "am-ET", dataValue: "amETData" },
  { name: "Arabic (Algeria)", value: "ar-DZ", dataValue: "arDZData" },
  { name: "Arabic (Bahrain)", value: "ar-BH", dataValue: "arBHData" },
  { name: "Arabic (Egypt)", value: "ar-EG", dataValue: "arEGData" },
  { name: "Arabic (Iraq)", value: "ar-IQ", dataValue: "arIQData" },
  { name: "Arabic (Jordan)", value: "ar-JO", dataValue: "arJOData" },
  { name: "Arabic (Kuwait)", value: "ar-KW", dataValue: "arKWData" },
  { name: "Arabic (Libya)", value: "ar-LY", dataValue: "arLYData" },
  { name: "Arabic (Lebanon)", value: "ar-LB", dataValue: "arLBData" },
  { name: "Arabic (Morocco)", value: "ar-MA", dataValue: "arMAData" },
  { name: "Arabic (Oman)", value: "ar-OM", dataValue: "arOMData" },
  { name: "Arabic (Qatar)", value: "ar-QA", dataValue: "arQAData" },
  { name: "Arabic (Saudi Arabia)", value: "ar-SA", dataValue: "arSAData" },
  { name: "Arabic (Syria)", value: "ar-SY", dataValue: "arSYData" },
  { name: "Arabic (Tunisia)", value: "ar-TN", dataValue: "arTNData" },
  {
    name: "Arabic (United Arab Emirates)",
    value: "ar-AE",
    dataValue: "arAEData",
  },
  { name: "Arabic (Yemen)", value: "ar-YE", dataValue: "arYEData" },
  { name: "Armenian (Armenia)", value: "hy-AM", dataValue: "hyAMData" },

  {
    name: "Azerbaijani (Latin, Azerbaijan)",
    value: "az-AZ",
    dataValue: "azAZData",
  },
  { name: "Bangla (Bangladesh)", value: "bn-BD", dataValue: "bnBDData" },
  { name: "Bengali (India)", value: "bn-IN", dataValue: "bnINData" },
  { name: "Basque - Basque", value: "eu-ES", dataValue: "euESData" },
  {
    name: "Bosnian (Bosnia and Herzegovina)",
    value: "bs-BA",
    dataValue: "bsBAData",
  },
  { name: "Bulgarian (Bulgaria)", value: "bg-BG", dataValue: "bgBGData" },
  { name: "Burmese (Myanmar)", value: "my-MM", dataValue: "myMMData" },
  { name: "Catalan (Spain)", value: "ca-ES", dataValue: "caESData" },
  {
    name: "Chinese (Cantonese, Traditional)",
    value: "zh-HK",
    dataValue: "zhHKData",
  },
  {
    name: "Chinese (Cantonese, Simplified)",
    value: "yue-CN",
    dataValue: "yueCNData",
  },
  {
    name: "Chinese (Mandarin, Simplified)",
    value: "zh-CN",
    dataValue: "zhCNData",
  },
  {
    name: "Chinese (Taiwanese Mandarin)",
    value: "zh-TW",
    dataValue: "zhTWData",
  },
  { name: "Chinese (Wu, Simplified)", value: "wuu-CN", dataValue: "wuuCNData" },

  { name: "Croatian (Croatia)", value: "hr-HR", dataValue: "hrHRData" },
  { name: "Czech (Czech)", value: "cs-CZ", dataValue: "csCZData" },
  { name: "Danish (Denmark)", value: "da-DK", dataValue: "daDKData" },
  { name: "Dutch (Belgium)", value: "nl-BE", dataValue: "nlBEData" },
  { name: "Dutch (Netherlands)", value: "nl-NL", dataValue: "nlNLData" },
  { name: "English (Australia)", value: "en-AU", dataValue: "enAUData" },
  { name: "English (Canada)", value: "en-CA", dataValue: "enCAData" },
  { name: "English (Hongkong)", value: "en-HK", dataValue: "enHKData" },
  { name: "English (India)", value: "en-IN", dataValue: "enINData" },
  { name: "English (Ireland)", value: "en-IE", dataValue: "enIEData" },
  { name: "English (Kenya)", value: "en-KE", dataValue: "enKEData" },
  { name: "English (New Zealand)", value: "en-NZ", dataValue: "enNZData" },
  { name: "English (Nigeria)", value: "en-NG", dataValue: "enNGData" },
  { name: "English (Philippines)", value: "en-PH", dataValue: "enPHData" },
  { name: "English (Singapore)", value: "en-SG", dataValue: "enSGData" },
  { name: "English (South Africa)", value: "en-ZA", dataValue: "enZAData" },
  { name: "English (Tanzania)", value: "en-TZ", dataValue: "enTZData" },
  { name: "English (United Kingdom)", value: "en-GB", dataValue: "enGBData" },
  { name: "English (United States)", value: "en-US", dataValue: "enUSData" },
  { name: "Estonian (Estonia)", value: "et-EE", dataValue: "etEEData" },
  { name: "Filipino (Philippines)", value: "fil-PH", dataValue: "filPHData" },
  { name: "Finnish (Finland)", value: "fi-FI", dataValue: "fiFIData" },
  { name: "French (Belgium)", value: "fr-BE", dataValue: "frBEData" },
  { name: "French (Canada)", value: "fr-CA", dataValue: "frCAData" },
  { name: "French (France)", value: "fr-FR", dataValue: "frFRData" },
  { name: "French (Switzerland)", value: "fr-CH", dataValue: "frCHData" },
  { name: "Galician (Galician)", value: "gl-ES", dataValue: "glESData" },
  { name: "German (Austria)", value: "de-AT", dataValue: "deATData" },
  { name: "German (Germany)", value: "de-DE", dataValue: "deDEData" },
  { name: "German (Switzerland)", value: "de-CH", dataValue: "deCHData" },
  { name: "Georgian (Georgia)", value: "ka-GE", dataValue: "kaGEData" },
  { name: "Greek (Greece)", value: "el-GR", dataValue: "elGRData" },
  { name: "Gujarati (India)", value: "gu-IN", dataValue: "guINData" },
  { name: "Hebrew (Israel)", value: "he-IL", dataValue: "heILData" },
  { name: "Hindi (India)", value: "hi-IN", dataValue: "hiINData" },
  { name: "Hungarian (Hungary)", value: "hu-HU", dataValue: "huHUData" },
  { name: "Icelandic (Iceland)", value: "is-IS", dataValue: "isISData" },
  { name: "Indonesian (Indonesia)", value: "id-ID", dataValue: "idIDData" },
  { name: "Irish (Ireland)", value: "ga-IE", dataValue: "gaIEData" },
  { name: "Italian (Italy)", value: "it-IT", dataValue: "itITData" },
  { name: "Japanese (Japan)", value: "ja-JP", dataValue: "jaJPData" },
  { name: "Javanese (Indonesia)", value: "jv-ID", dataValue: "jvIDData" },
  { name: "Kannada (India)", value: "kn-IN", dataValue: "knINData" },
  { name: "Kazakh (Kazakhstan)", value: "kk-KZ", dataValue: "kkKZData" },
  { name: "Khmer (Cambodia)", value: "km-KH", dataValue: "kmKHData" },
  { name: "Korean (Korea)", value: "ko-KR", dataValue: "koKRData" },
  { name: "Lao (Laos)", value: "lo-LA", dataValue: "loLAData" },
  { name: "Latvian (Latvia)", value: "lv-LV", dataValue: "lvLVData" },
  { name: "Lithuanian (Lithuania)", value: "lt-LT", dataValue: "ltLTData" },
  {
    name: "Macedonian (Republic of North Macedonia)",
    value: "mk-MK",
    dataValue: "mkMKData",
  },
  { name: "Malay (Malaysia)", value: "ms-MY", dataValue: "msMYData" },
  { name: "Malayalam (India)", value: "ml-IN", dataValue: "mlINData" },
  { name: "Mongolian (Mongolia)", value: "mn-MN", dataValue: "mnMNData" },
  { name: "Maltese (Malta)", value: "mt-MT", dataValue: "mtMTData" },
  { name: "Marathi (India)", value: "mr-IN", dataValue: "mrINData" },
  { name: "Nepali (Nepal)", value: "ne-NP", dataValue: "neNPData" },
  { name: "Norwegian (Bokmål, Norway)", value: "nb-NO", dataValue: "nbNOData" },
  { name: "Pashto (Afghanistan)", value: "ps-AF", dataValue: "psAFData" },
  { name: "Persian (Iran)", value: "fa-IR", dataValue: "faIRData" },
  { name: "Polish (Poland)", value: "pl-PL", dataValue: "plPLData" },
  { name: "Portuguese (Brazil)", value: "pt-BR", dataValue: "ptBRData" },
  { name: "Portuguese (Portugal)", value: "pt-PT", dataValue: "ptPTData" },
  { name: "Romanian (Romania)", value: "ro-RO", dataValue: "roROData" },
  { name: "Russian (Russia)", value: "ru-RU", dataValue: "ruRUData" },
  { name: "Serbian (Serbia, Cyrillic)", value: "sr-RS", dataValue: "srRSData" },
  { name: "Sinhala (Sri Lanka)", value: "si-LK", dataValue: "siLKData" },
  { name: "Slovak (Slovakia)", value: "sk-SK", dataValue: "skSKData" },
  { name: "Slovenian (Slovenia)", value: "sl-SI", dataValue: "slSIData" },
  { name: "Somali (Somalia)", value: "so-SO", dataValue: "soSOData" },
  { name: "Spanish (Argentina)", value: "es-AR", dataValue: "esARData" },
  { name: "Spanish (Bolivia)", value: "es-BO", dataValue: "esBOData" },
  { name: "Spanish (Chile)", value: "es-CL", dataValue: "esCLData" },
  { name: "Spanish (Colombia)", value: "es-CO", dataValue: "esCOData" },
  { name: "Spanish (Costa Rica)", value: "es-CR", dataValue: "esCRData" },
  { name: "Spanish (Cuba)", value: "es-CU", dataValue: "esCUData" },
  {
    name: "Spanish (Dominican Republic)",
    value: "es-DO",
    dataValue: "esDOData",
  },
  { name: "Spanish (Ecuador)", value: "es-EC", dataValue: "esECData" },
  { name: "Spanish (El Salvador)", value: "es-SV", dataValue: "esSVData" },
  {
    name: "Spanish (Equatorial Guinea)",
    value: "es-GQ",
    dataValue: "esGQData",
  },
  { name: "Spanish (Guatemala)", value: "es-GT", dataValue: "esGTData" },
  { name: "Spanish (Honduras)", value: "es-HN", dataValue: "esHNData" },
  { name: "Spanish (Mexico)", value: "es-MX", dataValue: "esMXData" },
  { name: "Spanish (Nicaragua)", value: "es-NI", dataValue: "esNIData" },
  { name: "Spanish (Panama)", value: "es-PA", dataValue: "esPAData" },
  { name: "Spanish (Paraguay)", value: "es-PY", dataValue: "esPYData" },
  { name: "Spanish (Peru)", value: "es-PE", dataValue: "esPEData" },
  { name: "Spanish (Puerto Rico)", value: "es-PR", dataValue: "esPRData" },
  { name: "Spanish (Spain)", value: "es-ES", dataValue: "esESData" },
  { name: "Spanish (Uruguay)", value: "es-UY", dataValue: "esUYData" },
  { name: "Spanish (United States)", value: "es-US", dataValue: "esUSData" },
  { name: "Spanish (Venezuela)", value: "es-VE", dataValue: "esVEData" },
  { name: "Sundanese (Indonesia)", value: "su-ID", dataValue: "suIDData" },
  { name: "Swahili (Kenya)", value: "sw-KE", dataValue: "swKEData" },
  { name: "Swahili (Tanzania)", value: "sw-TZ", dataValue: "swTZData" },
  { name: "Swedish (Sweden)", value: "sv-SE", dataValue: "svSEData" },
  { name: "Tamil (India)", value: "ta-IN", dataValue: "taINData" },
  { name: "Tamil (Malaysia)", value: "ta-MY", dataValue: "taMYData" },
  { name: "Tamil (Singapore)", value: "ta-SG", dataValue: "taSGData" },
  { name: "Tamil (Sri Lanka)", value: "ta-LK", dataValue: "taLKData" },
  { name: "Telugu (India)", value: "te-IN", dataValue: "teINData" },
  { name: "Thai (Thailand)", value: "th-TH", dataValue: "thTHData" },
  { name: "Turkish (Turkey)", value: "tr-TR", dataValue: "trTRData" },
  { name: "Ukrainian (Ukraine)", value: "uk-UA", dataValue: "uk-UAData" },
  { name: "Urdu (India)", value: "ur-IN", dataValue: "urINData" },
  { name: "Urdu (Pakistan)", value: "ur-PK", dataValue: "urPKData" },
  { name: "Uzbek (Uzbekistan)", value: "uz-UZ", dataValue: "uzUZData" },
  { name: "Vietnamese (Vietnam)", value: "vi-VN", dataValue: "viVNData" },
  { name: "Welsh (United Kingdom)", value: "cy-GB", dataValue: "cyGBData" },
  { name: "Zulu (South Africa)", value: "zu-ZA", dataValue: "zuZAData" },
];

export const languageDubbingArray = [
  { name: "chinese", code: "zh" },
  { name: "korean", code: "ko" },
  { name: "dutch", code: "nl" },
  { name: "turkish", code: "tr" },
  { name: "swedish", code: "sv" },
  { name: "indonesian", code: "id" },
  { name: "filipino", code: "tl" },
  { name: "japanese", code: "ja" },
  { name: "ukrainian", code: "uk" },
  { name: "greek", code: "el" },
  { name: "czech", code: "cs" },
  { name: "finnish", code: "fi" },
  { name: "romanian", code: "ro" },
  { name: "russian", code: "ru" },
  { name: "danish", code: "da" },
  { name: "bulgarian", code: "bg" },
  { name: "malay", code: "ms" },
  { name: "slovak", code: "sk" },
  { name: "croatian", code: "hr" },
  { name: "arabic", code: "ar" },
  { name: "tamil", code: "ta" },
  { name: "english", code: "en" },
  { name: "polish", code: "pl" },
  { name: "german", code: "de" },
  { name: "spanish", code: "es" },
  { name: "french", code: "fr" },
  { name: "italian", code: "it" },
  { name: "hindi", code: "hi" },
  { name: "portuguese", code: "pt" },
  { name: "hungarian", code: "hu" },
  { name: "vietnamese", code: "vi" },
  { name: "norwegian", code: "no" },
];

export const LANGUAGE_VOICES = NEW_LANGUAGE_VOICE || {
  afZA: [
    { name: "Adri (Neural)", gender: "Female", value: "af-ZA-AdriNeural" },
    { name: "Willem (Neural)", gender: "Male", value: "af-ZA-WillemNeural" },
  ],
  sqAL: [
    { name: "Anila", gender: "Female", value: "sq-AL-AnilaNeural" },
    { name: "Ilir", gender: "Male", value: "sq-AL-IlirNeural" },
  ],
  amET: [
    {
      name: "Ameha (Neural) - አምሀ",
      gender: "Female",
      value: "am-ET-AmehaNeural",
    },
    {
      name: "Mekdes (Neural) - መቅደስ",
      gender: "Male",
      value: "am-ET-MekdesNeural",
    },
  ],
  arDZ: [
    {
      name: "Amina (Neural) - أمينة",
      gender: "Female",
      value: "ar-DZ-AminaNeural",
    },
    {
      name: "Ismael (Neural) - إسماعيل",
      gender: "Male",
      value: "ar-DZ-IsmaelNeural",
    },
  ],
  arBH: [
    { name: "Ali (Neural) - علي", gender: "Male", value: "ar-BH-AliNeural" },
    {
      name: "Laila (Neural) - ليلى",
      gender: "Female",
      value: "ar-BH-LailaNeural",
    },
  ],

  arEG: [
    {
      name: "Salma (Neural) - سلمى",
      gender: "Female",
      value: "ar-EG-SalmaNeural",
    },
    {
      name: "Shakir (Neural) - شاكر",
      gender: "Male",
      value: "ar-EG-ShakirNeural",
    },
  ],
  arIQ: [
    {
      name: "Bassel (Neural) - باسل",
      gender: "Male",
      value: "ar-IQ-BasselNeural",
    },
    {
      name: "Rana (Neural) - رنا",
      gender: "Female",
      value: "ar-IQ-RanaNeural",
    },
  ],
  arJO: [
    {
      name: "Sana (Neural) - سناء",
      gender: "Female",
      value: "ar-JO-SanaNeural",
    },
    { name: "Taim (Neural) - تيم", gender: "Male", value: "ar-JO-TaimNeural" },
  ],
  arKW: [
    {
      name: "Fahed (Neural) - فهد",
      gender: "Male",
      value: "ar-KW-FahedNeural",
    },
    {
      name: "Noura (Neural) - نورا",
      gender: "Female",
      value: "ar-KW-NouraNeural",
    },
  ],

  arLY: [
    {
      name: "Iman (Neural) - إيمان",
      gender: "Female",
      value: "ar-LY-ImanNeural",
    },
    { name: "Omar (Neural) - أحمد", gender: "Male", value: "ar-LY-OmarNeural" },
  ],
  arLB: [
    { name: "Layla - ليلى", gender: "Female", value: "ar-LB-LaylaNeural" },
    { name: "Rami - رامي", gender: "Male", value: "ar-LB-RamiNeural" },
  ],
  arMA: [
    {
      name: "Jamal (Neural) - جمال",
      gender: "Male",
      value: "ar-MA-JamalNeural",
    },
    {
      name: "Mouna (Neural) - منى",
      gender: "Female",
      value: "ar-MA-MounaNeural",
    },
  ],
  arOM: [
    { name: "Aysha - عائشة", gender: "Female", value: "ar-OM-AyshaNeural" },
    {
      name: "Abdullah - عبدالله",
      gender: "Male",
      value: "ar-OM-AbdullahNeural",
    },
  ],
  arQA: [
    {
      name: "Amal (Neural) - أمل",
      gender: "Female",
      value: "ar-QA-AmalNeural",
    },
    { name: "Moaz (Neural) - معاذ", gender: "Male", value: "ar-QA-MoazNeural" },
  ],
  arSA: [
    {
      name: "Hamed (Neural) - حامد",
      gender: "Male",
      value: "ar-SA-HamedNeural",
    },
    {
      name: "Zariyah (Neural) - زارية",
      gender: "Female",
      value: "ar-SA-ZariyahNeural",
    },
  ],
  arSY: [
    {
      name: "Amany (Neural) - أماني",
      gender: "Female",
      value: "ar-SY-AmanyNeural",
    },
    {
      name: "Laith (Neural) - ليث",
      gender: "Male",
      value: "ar-SY-LaithNeural",
    },
  ],
  arTN: [
    { name: "Hedi (Neural) - هادي", gender: "Male", value: "ar-TN-HediNeural" },
    {
      name: "Reem (Neural) - ريم",
      gender: "Female",
      value: "ar-TN-ReemNeural",
    },
  ],
  arAE: [
    {
      name: "Fatima (Neural) - فاطمة",
      gender: "Female",
      value: "ar-AE-FatimaNeural",
    },
    {
      name: "Hamdan (Neural) - حمدان",
      gender: "Male",
      value: "ar-AE-HamdanNeural",
    },
  ],
  arYE: [
    {
      name: "Maryam (Neural) - مريم",
      gender: "Female",
      value: "ar-YE-MaryamNeural",
    },
    {
      name: "Saleh (Neural) - صالح",
      gender: "Male",
      value: "ar-YE-SalehNeural",
    },
  ],
  hyAM: [
    { name: "Anahit - Անահիտ", gender: "Female", value: "hy-AM-AnahitNeural" },
    { name: "Hayk", gender: "Male", value: "hy-AM-HaykNeural" },
  ],
  azAZ: [
    { name: "Banu", gender: "Female", value: "az-AZ-BanuNeural" },
    { name: "Babək - Babək", gender: "Male", value: "az-AZ-BabəkNeural" },
  ],
  bnBD: [
    {
      name: "Nabanita (Neural) - নবনীতা",
      gender: "Female",
      value: "bn-BD-NabanitaNeural",
    },
    {
      name: "Pradeep (Neural) - প্রদ্বীপ",
      gender: "Male",
      value: "bn-BD-PradeepNeural",
    },
  ],
  bnIN: [
    {
      name: "Bashkar (Neural) - ভাস্কর",
      gender: "Male",
      value: "bn-IN-BashkarNeural",
    },
    {
      name: "Tanishaa (Neural) - তানিশা",
      gender: "Female",
      value: "bn-IN-TanishaaNeural",
    },
  ],
  euES: [
    { name: "Ander", gender: "Male", value: "eu-ES-AnderNeural" },
    { name: "Ainhoa", gender: "Female", value: "eu-ESN-AinhoaNeural" },
  ],
  bsBA: [
    { name: "Goran", gender: "Male", value: "bn-IN-GoranNeural" },
    { name: "Vesna", gender: "Female", value: "bn-IN-VesnaNeural" },
  ],
  bgBG: [
    {
      name: "Borislav (Neural) - Борислав",
      gender: "Male",
      value: "bg-BG-BorislavNeural",
    },
    {
      name: "Kalina (Neural) - Калина",
      gender: "Female",
      value: "bg-BG-KalinaNeural",
    },
  ],
  myMM: [
    {
      name: "Nilar (Neural) - နီလာ",
      gender: "Female",
      value: "my-MM-NilarNeural",
    },
    {
      name: "Thiha (Neural) - သီဟ",
      gender: "Male",
      value: "my-MM-ThihaNeural",
    },
  ],
  caES: [
    { name: "Joana (Neural)", gender: "Female", value: "ca-ES-JoanaNeural" },
    { name: "Alba (Neural)", gender: "Female", value: "ca-ES-AlbaNeural" },
    { name: "Enric (Neural)", gender: "Male", value: "ca-ES-EnricNeural" },
  ],
  zhHK: [
    {
      name: "HiuMaan (Neural) - 曉曼",
      gender: "Female",
      value: "zh-HK-HiuMaanNeural",
    },
    {
      name: "HiuGaai (Neural) - 曉佳",
      gender: "Female",
      value: "zh-HK-HiuGaaiNeural",
    },
    {
      name: "WanLung (Neural) - 雲龍",
      gender: "Male",
      value: "zh-HK-WanLungNeural",
    },
  ],
  yueCN: [
    { name: "XiaoMin - 晓敏", gender: "Female", value: "yue-CN-XiaoMinNeural" },
    { name: "YunSong - 云松", gender: "Male", value: "yue-CN-YunSongNeural" },
  ],
  zhCN: [
    {
      name: "Xiaoxiao (Neural) - 晓晓 *",
      gender: "Female",
      value: "zh-CN-XiaoxiaoNeural",
      dataValue: "zhCNXiaoxiaoNeural",
    },
    {
      name: "Yunyang (Neural) - 云扬 *",
      gender: "Male",
      value: "zh-CN-YunyangNeural",
      dataValue: "zhCNYunyangNeural",
    },
    {
      name: "Xiaochen (Neural) - 晓辰",
      gender: "Female",
      value: "zh-CN-XiaochenNeural",
    },
    {
      name: "Xiaohan (Neural) - 晓涵 *",
      gender: "Female",
      value: "zh-CN-XiaohanNeural",
      dataValue: "zhCNXiaohanNeural",
    },
    {
      name: "Xiaomo (Neural) - 晓墨 *",
      gender: "Female",
      value: "zh-CN-XiaomoNeural",
      dataValue: "zhCNXiaomoNeural",
    },
    {
      name: "Xiaoqiu (Neural) - 晓秋",
      gender: "Female",
      value: "zh-CN-XiaoqiuNeural",
    },
  ],
  zhTW: [
    {
      name: "HsiaoChen (Neural) - 曉臻",
      gender: "Female",
      value: "zh-TW-HsiaoChenNeural",
    },
    {
      name: "HsiaoYu (Neural) - 曉雨",
      gender: "Female",
      value: "zh-TW-HsiaoYuNeural",
    },
    {
      name: "YunJhe (Neural) - 雲哲",
      gender: "Male",
      value: "zh-TW-YunJheNeural",
    },
  ],

  wuuCN: [
    {
      name: "Xiaotong - 晓彤",
      gender: "Female",
      value: "wuu-CN-XiaotongNeural",
    },
    { name: "Yunzhe - 云哲", gender: "Male", value: "wuu-CN-YunzheNeural" },
  ],

  hrHR: [
    {
      name: "Gabrijela (Neural)",
      gender: "Female",
      value: "hr-HR-GabrijelaNeural",
    },
    {
      name: "Srecko (Neural) - Srećko",
      gender: "Male",
      value: "hr-HR-SreckoNeural",
    },
  ],
  csCZ: [
    {
      name: "Antonin (Neural) - Antonín",
      gender: "Male",
      value: "cs-CZ-AntoninNeural",
    },
    { name: "Vlasta (Neural)", gender: "Female", value: "cs-CZ-VlastaNeural" },
  ],
  daDK: [
    {
      name: "Christel (Neural)",
      gender: "Female",
      value: "da-DK-ChristelNeural",
    },
    { name: "Jeppe (Neural)", gender: "Male", value: "da-DK-JeppeNeural" },
  ],
  nlBE: [
    { name: "Arnaud (Neural)", gender: "Male", value: "nl-BE-ArnaudNeural" },
    { name: "Dena (Neural)", gender: "Female", value: "nl-BE-DenaNeural" },
  ],
  nlNL: [
    {
      name: "Colette (Neural)",
      gender: "Female",
      value: "nl-NL-ColetteNeural",
    },
    { name: "Fenna (Neural)", gender: "Female", value: "nl-NL-FennaNeural" },
    { name: "Maarten (Neural)", gender: "Male", value: "nl-NL-MaartenNeural" },
  ],
  enAU: [
    { name: "Annette", gender: "Female", value: "en-AU-AnnetteNeural" },
    { name: "Carly", gender: "Female", value: "en-AU-CarlyNeural" },
    { name: "Elsie", gender: "Female", value: "en-AU-ElsieNeural" },
    { name: "Freya", gender: "Female", value: "en-AU-FreyaNeural" },
    { name: "Joanne", gender: "Female", value: "en-AU-JoanneNeural" },
    { name: "Kim", gender: "Female", value: "en-AU-KimNeural" },
    {
      name: "Natasha (Neural)",
      gender: "Female",
      value: "en-AU-NatashaNeural",
    },

    { name: "William (Neural)", gender: "Male", value: "en-AU-WilliamNeural" },
    { name: "Darren", gender: "Male", value: "en-AU-DarrenNeural" },
    { name: "Darren", gender: "Male", value: "en-AU-DarrenNeural" },
    { name: "Ken", gender: "Male", value: "en-AU-KenNeural" },
    { name: "Neil", gender: "Male", value: "en-AU-NeilNeural" },
    { name: "Tim", gender: "Male", value: "en-AU-TimNeural" },
  ],
  enCA: [
    { name: "Clara (Neural)", gender: "Female", value: "en-CA-ClaraNeural" },
    { name: "Liam (Neural)", gender: "Male", value: "en-CA-LiamNeural" },
  ],
  enHK: [
    { name: "Sam (Neural)", gender: "Male", value: "en-HK-SamNeural" },
    { name: "Yan (Neural)", gender: "Female", value: "en-HK-YanNeural" },
  ],
  enIN: [
    { name: "Neerja (Neural)", gender: "Female", value: "en-IN-NeerjaNeural" },
    { name: "Prabhat (Neural)", gender: "Male", value: "en-IN-PrabhatNeural" },
  ],
  enIE: [
    { name: "Connor (Neural)", gender: "Male", value: "en-IE-ConnorNeural" },
    { name: "Emily (Neural)", gender: "Female", value: "en-IE-EmilyNeural" },
  ],
  enKE: [
    { name: "Asilia (Neural)", gender: "Female", value: "en-KE-AsiliaNeural" },
    {
      name: "Chilemba (Neural)",
      gender: "Male",
      value: "en-KE-ChilembaNeural",
    },
  ],
  enNZ: [
    {
      name: "Mitchell (Neural)",
      gender: "Male",
      value: "en-NZ-MitchellNeural",
    },
    { name: "Molly (Neural)", gender: "Female", value: "en-NZ-MollyNeural" },
  ],
  enNG: [
    { name: "Abeo (Neural)", gender: "Male", value: "en-NG-AbeoNeural" },
    { name: "Ezinne (Neural)", gender: "Female", value: "en-NG-EzinneNeural" },
  ],
  enPH: [
    { name: "James (Neural)", gender: "Male", value: "en-PH-JamesNeural" },
    { name: "Rosa (Neural)", gender: "Female", value: "en-PH-RosaNeural" },
  ],
  enSG: [
    { name: "Luna (Neural)", gender: "Female", value: "en-SG-LunaNeural" },
    { name: "Wayne (Neural)", gender: "Male", value: "en-SG-WayneNeural" },
  ],
  enZA: [
    { name: "Leah (Neural)", gender: "Female", value: "en-ZA-LeahNeural" },
    { name: "Luke (Neural)", gender: "Male", value: "en-ZA-LukeNeural" },
  ],
  enTZ: [
    { name: "Elimu (Neural)", gender: "Male", value: "en-TZ-ElimuNeural" },
    { name: "Imani (Neural)", gender: "Female", value: "en-TZ-ImaniNeural" },
  ],
  enGB: [
    { name: "Libby (Neural)", gender: "Female", value: "en-GB-LibbyNeural" },
    {
      name: "Sonia (Neural) *",
      gender: "Female",
      value: "en-GB-SoniaNeural",
      dataValue: "enGBSoniaNeural",
    },
    { name: "Bella (Neural)", gender: "Female", value: "en-GB-BellaNeural" },
    { name: "Abbi (Neural)", gender: "Female", value: "en-GB-AbbiNeural" },
    { name: "Hollie", gender: "Female", value: "en-GB-HollieNeural" },
    { name: "Masie", gender: "Female", value: "en-GB-MasieNeural" },
    { name: "Olivia", gender: "Female", value: "en-GB-OliviaNeural" },
    {
      name: "Ryan (Neural) *",
      gender: "Male",
      value: "en-GB-RyanNeural",
      dataValue: "enGBRyanNeural",
    },
    {
      name: "Alfie (Neural) - Preview",
      gender: "Male",
      value: "en-GB-AlfieNeural",
    },
    {
      name: "Elliot (Neural) - Preview",
      gender: "Male",
      value: "en-GB-ElliotNeural",
    },
    { name: "Noah", gender: "Male", value: "en-GB-NoohNeural" },
    { name: "Oliver", gender: "Male", value: "en-GB-OliverNeural" },
    {
      name: "Ethan (Neural) - Preview",
      gender: "Male",
      value: "en-GB-EthanNeural",
    },
  ],
  enUS: [
    {
      name: "Jenny *",
      gender: "Female",
      value: "en-US-JennyNeural",
      dataValue: "enUSJennyNeural",
    },
    {
      name: "Jenny Multilingual",
      gender: "Female",
      value: "en-US-JennyMultilingualNeural",
    },
    { name: "Amber", gender: "Female", value: "en-US-AmberNeural" },
    { name: "Ana", gender: "Female", value: "en-US-AnaNeural" },
    {
      name: "Aria *",
      gender: "Female",
      value: "en-US-AriaNeural",
      dataValue: "enUSAriaNeural",
    },
    { name: "Cora", gender: "Female", value: "en-US-CoraNeural" },
    { name: "Ashley", gender: "Female", value: "en-US-AshleyNeural" },
    { name: "Elizabeth", gender: "Female", value: "en-US-ElizabethNeural" },
    {
      name: "Jane *",
      gender: "Female",
      value: "en-US-JaneNeural",
      dataValue: "enUSJaneNeural",
    },
    { name: "AIgenerate2", gender: "Female", value: "en-US-AIgenerate2Neural" },
    {
      name: "Sara *",
      gender: "Female",
      value: "en-US-SaraNeural",
      dataValue: "enUSSaraNeural",
    },
    {
      name: "Nancy *",
      gender: "Female",
      value: "en-US-NancyNeural",
      dataValue: "enUSNancyNeural",
    },
    { name: "Monica", gender: "Female", value: "en-US-MonicaNeural" },
    { name: "Michelle", gender: "Female", value: "en-US-MichelleNeural" },
    {
      name: "Guy *",
      gender: "Male",
      value: "en-US-GuyNeural",
      dataValue: "enUSGuyNeural",
    },
    { name: "Brandon", gender: "Male", value: "en-US-BrandonNeural" },
    { name: "Christopher", gender: "Male", value: "en-US-ChristopherNeural" },
    { name: "AIGenerate1", gender: "Male", value: "en-US-AIGenerate1Neural" },
    { name: "Steffan", gender: "Male", value: "en-US-SteffanNeural" },
    { name: "Roger", gender: "Male", value: "en-US-RogerNeural" },
    { name: "Jacob", gender: "Male", value: "en-US-JacobNeural" },
    { name: "Eric", gender: "Male", value: "en-US-EricNeural" },
    {
      name: "Jason *",
      gender: "Male",
      value: "en-US-JasonNeural",
      dataValue: "enUSJasonNeural",
    },
    {
      name: "Davis *",
      gender: "Male",
      value: "en-US-DavisNeural",
      dataValue: "enUSDavisNeural",
    },
  ],
  etEE: [
    { name: "Anu (Neural)", gender: "Female", value: "et-EE-AnuNeural" },
    { name: "Kert (Neural)", gender: "Male", value: "et-EE-KertNeural" },
  ],
  filPH: [
    { name: "Angelo (Neural)", gender: "Male", value: "fil-PH-AngeloNeural" },
    {
      name: "Blessica (Neural)",
      gender: "Female",
      value: "fil-PH-BlessicaNeural",
    },
  ],
  fiFI: [
    { name: "Selma (Neural)", gender: "Female", value: "fi-FI-SelmaNeural" },
    { name: "Harri (Neural)", gender: "Male", value: "fi-FI-HarriNeural" },
    { name: "Noora (Neural)", gender: "Female", value: "fi-FI-NooraNeural" },
  ],
  frBE: [
    {
      name: "Charline (Neural)",
      gender: "Female",
      value: "fr-BE-CharlineNeural",
    },
    { name: "Gerard (Neural)", gender: "Male", value: "fr-BE-GerardNeural" },
  ],
  frCA: [
    { name: "Sylvie (Neural)", gender: "Female", value: "fr-CA-SylvieNeural" },
    { name: "Antoine (Neural)", gender: "Male", value: "fr-CA-AntoineNeural" },
    { name: "Jean (Neural)", gender: "Male", value: "fr-CA-JeanNeural" },
  ],
  frFR: [
    {
      name: "Denise *",
      gender: "Female",
      value: "fr-FR-DeniseNeural",
      dataValue: "frFRDeniseNeural",
    },
    { name: "Brigitte", gender: "Female", value: "fr-FR-BrigitteNeural" },
    { name: "Celeste", gender: "Female", value: "fr-FR-CelesteNeural" },
    { name: "Coralie", gender: "Female", value: "fr-FR-CoralieNeural" },
    { name: "Eloise", gender: "Female", value: "fr-FR-EloiseNeural" },
    { name: "Jacqueline", gender: "Female", value: "fr-FR-JacquelineNeural" },
    { name: "Yvette", gender: "Female", value: "fr-FR-YvetteNeural" },
    { name: "Celeste", gender: "Female", value: "fr-FR-CelesteNeural" },

    {
      name: "Henri *",
      gender: "Male",
      value: "fr-FR-HenriNeural",
      dataValue: "frFRHenriNeural",
    },
    { name: "Alain", gender: "Male", value: "fr-FR-AlainNeural" },
    { name: "Claude", gender: "Male", value: "fr-FR-ClaudeNeural" },
    { name: "Maurice", gender: "Male", value: "fr-FR-MauriceNeural" },
    { name: "Jerome", gender: "Male", value: "fr-FR-JeromeNeural" },
    { name: "Yves", gender: "Male", value: "fr-FR-YvesNeural" },
  ],
  frCH: [
    { name: "Ariane (Neural)", gender: "Female", value: "fr-CH-ArianeNeural" },
    { name: "Fabrice (Neural)", gender: "Male", value: "fr-CH-FabriceNeural" },
  ],
  glES: [
    { name: "Roi (Neural)", gender: "Male", value: "gl-ES-RoiNeural" },
    { name: "Sabela (Neural)", gender: "Female", value: "gl-ES-SabelaNeural" },
  ],
  deAT: [
    { name: "Ingrid (Neural)", gender: "Female", value: "de-AT-IngridNeural" },
    { name: "Jonas (Neural)", gender: "Male", value: "de-AT-JonasNeural" },
  ],
  deDE: [
    { name: "Katja", gender: "Female", value: "de-DE-KatjaNeural" },
    { name: "Amala", gender: "Female", value: "de-DE-AmalaNeural" },
    { name: "Elke", gender: "Female", value: "de-DE-ElkeNeural" },
    { name: "Gisela", gender: "Female", value: "de-DE-GiselaNeural" },
    { name: "Klarissa", gender: "Female", value: "de-DE-KlarissaNeural" },
    { name: "Maja", gender: "Female", value: "de-DE-MajaNeural" },
    { name: "Louisa", gender: "Female", value: "de-DE-LouisaNeural" },
    { name: "Tanja", gender: "Female", value: "de-DE-TanjaNeural" },

    { name: "Bernd", gender: "Male", value: "de-DE-BerndNeural" },
    { name: "Christoph", gender: "Male", value: "de-DE-ChristophNeural" },
    { name: "Conrad", gender: "Male", value: "de-DE-ConradNeural" },
    { name: "Killian", gender: "Male", value: "de-DE-KillianNeural" },
    { name: "Klaus", gender: "Male", value: "de-DE-KlausNeural" },
    { name: "Kasper", gender: "Male", value: "de-DE-KasperNeural" },
  ],

  kaGE: [
    { name: "Giorgi", gender: "Male", value: "ka-GE-GiorgiNeural" },
    { name: "Eka", gender: "Female", value: "ka-GE-EkaNeural" },
  ],
  deCH: [
    { name: "Jan (Neural)", gender: "Male", value: "de-CH-JanNeural" },
    { name: "Leni (Neural)", gender: "Female", value: "de-CH-LeniNeural" },
  ],
  elGR: [
    {
      name: "Athina (Neural) - Αθηνά",
      gender: "Female",
      value: "el-GR-AthinaNeural",
    },
    {
      name: "Nestoras (Neural) - Νέστορας",
      gender: "Male",
      value: "el-GR-NestorasNeural",
    },
  ],
  guIN: [
    {
      name: "Dhwani (Neural) - ધ્વની",
      gender: "Female",
      value: "gu-IN-DhwaniNeural",
    },
    {
      name: "Niranjan (Neural) - નિરંજન",
      gender: "Male",
      value: "gu-IN-NiranjanNeural",
    },
  ],
  heIL: [
    { name: "Avri (Neural) - אברי", gender: "Male", value: "he-IL-AvriNeural" },
    {
      name: "Hila (Neural) - הילה",
      gender: "Female",
      value: "he-IL-HilaNeural",
    },
  ],
  hiIN: [
    {
      name: "Madhur (Neural) - मधुर",
      gender: "Male",
      value: "hi-IN-MadhurNeural",
    },
    {
      name: "Swara (Neural) - स्वरा",
      gender: "Female",
      value: "hi-IN-SwaraNeural",
    },
  ],
  huHU: [
    {
      name: "Noemi (Neural) - Noémi",
      gender: "Female",
      value: "hu-HU-NoemiNeural",
    },
    {
      name: "Tamas (Neural) - Tamás",
      gender: "Male",
      value: "hu-HU-TamasNeural",
    },
  ],
  isIS: [
    {
      name: "Gudrun (Neural) - Guðrún",
      gender: "Female",
      value: "is-IS-GudrunNeural",
    },
    { name: "Gunnar (Neural)", gender: "Male", value: "is-IS-GunnarNeural" },
  ],
  idID: [
    { name: "Ardi (Neural)", gender: "Male", value: "id-ID-ArdiNeural" },
    { name: "Gadis (Neural)", gender: "Female", value: "id-ID-GadisNeural" },
  ],
  gaIE: [
    { name: "Colm (Neural)", gender: "Male", value: "ga-IE-ColmNeural" },
    { name: "Orla (Neural)", gender: "Female", value: "ga-IE-OrlaNeural" },
  ],
  itIT: [
    {
      name: "Isabella *",
      gender: "Female",
      value: "it-IT-IsabellaNeural",
      dataValue: "itITIsabellaNeural",
    },
    { name: "Elsa", gender: "Female", value: "it-IT-ElsaNeural" },
    { name: "Fabiola", gender: "Female", value: "it-IT-FabiolaNeural" },
    { name: "Fiamma", gender: "Female", value: "it-IT-FiammaNeural" },
    { name: "Imelda", gender: "Female", value: "it-IT-ImeldaNeural" },
    { name: "Irma", gender: "Female", value: "it-IT-IrmaNeural" },
    { name: "Palmira", gender: "Female", value: "it-IT-PalmiraNeural" },
    { name: "Pierina", gender: "Female", value: "it-IT-PierinaNeural" },
    { name: "Benigno", gender: "Male", value: "it-IT-BenignoNeural" },
    { name: "Calimero", gender: "Male", value: "it-IT-CalimeroNeural" },
    { name: "Calimero", gender: "Male", value: "it-IT-CalimeroNeural" },
    { name: "Gianni", gender: "Male", value: "it-IT-GianniNeural" },
    { name: "Lisandro", gender: "Male", value: "it-IT-LisandroNeural" },
    { name: "Rinaldo", gender: "Male", value: "it-IT-RinaldoNeural" },
    { name: "Diego", gender: "Male", value: "it-IT-DiegoNeural" },
  ],
  jaJP: [
    {
      name: "Nanami - 七海 *",
      gender: "Female",
      value: "ja-JP-NanamiNeural",
      dataValue: "jaJPNanamiNeural",
    },
    { name: "Aoi - 碧衣", gender: "Female", value: "ja-JP-AoiNeural" },
    { name: "Mayu - 真夕", gender: "Female", value: "ja-JP-MayuNeural" },
    { name: "Shiori - 志織", gender: "Female", value: "ja-JP-ShioriNeural" },
    { name: "Daichi - 大智", gender: "Male", value: "ja-JP-DaichiNeural" },
    { name: "Keita - 圭太", gender: "Male", value: "ja-JP-KeitaNeural" },
    { name: "Naoki - 直紀", gender: "Male", value: "ja-JP-NaokiNeural" },
  ],
  jvID: [
    { name: "Dimas (Neural)", gender: "Male", value: "jv-ID-DimasNeural" },
    { name: "Siti (Neural)", gender: "Female", value: "jv-ID-SitiNeural" },
  ],
  knIN: [
    {
      name: "Gagan (Neural) - ಗಗನ್",
      gender: "Male",
      value: "kn-IN-GaganNeural",
    },
    {
      name: "Sapna (Neural) - ಸಪ್ನಾ",
      gender: "Female",
      value: "kn-IN-SapnaNeural",
    },
  ],
  kkKZ: [
    {
      name: "Aigul (Neural) - Айгүл",
      gender: "Female",
      value: "kk-KZ-AigulNeural",
    },
    {
      name: "Daulet (Neural) - Дәулет",
      gender: "Male",
      value: "kk-KZ-DauletNeural",
    },
  ],
  kmKH: [
    {
      name: "Piseth (Neural) - ពិសិដ្ឋ",
      gender: "Male",
      value: "km-KH-PisethNeural",
    },
    {
      name: "Sreymom (Neural) - ស្រីមុំ",
      gender: "Female",
      value: "km-KH-SreymomNeural",
    },
  ],
  koKR: [
    { name: "Sun-Hi - 선히", gender: "Female", value: "ko-KR-SunHiNeural" },
    { name: "JiMin - 지민", gender: "Female", value: "ko-KR-JiMinNeural" },
    {
      name: "SeoHyeon - 서현",
      gender: "Female",
      value: "ko-KR-SeoHyeonNeural",
    },
    { name: "SoonBok - 순복", gender: "Female", value: "ko-KR-SoonBokNeural" },
    { name: "InJoon - 인준", gender: "Male", value: "ko-KR-InJoonNeural" },
    { name: "BongJin - 봉진", gender: "Male", value: "ko-KR-BongJinNeural" },
    { name: "GookMin - 국민", gender: "Male", value: "ko-KR-GookMinNeural" },
  ],
  loLA: [
    {
      name: "Chanthavong (Neural) - ຈັນທະວົງ",
      gender: "Male",
      value: "lo-LA-ChanthavongNeural",
    },
    {
      name: "Keomany (Neural) - ແກ້ວມະນີ",
      gender: "Female",
      value: "lo-LA-KeomanyNeural",
    },
  ],
  lvLV: [
    {
      name: "Everita (Neural)",
      gender: "Female",
      value: "lv-LV-EveritaNeural",
    },
    { name: "Nils (Neural)", gender: "Male", value: "lv-LV-NilsNeural" },
  ],
  ltLT: [
    { name: "Leonas (Neural)", gender: "Male", value: "lt-LT-LeonasNeural" },
    { name: "Ona (Neural)", gender: "Female", value: "lt-LT-OnaNeural" },
  ],
  mkMK: [
    {
      name: "Aleksandar (Neural) - Александар",
      gender: "Male",
      value: "mk-MK-AleksandarNeural",
    },
    {
      name: "Marija (Neural) - Марија",
      gender: "Female",
      value: "mk-MK-MarijaNeural",
    },
  ],
  msMY: [
    { name: "Osman (Neural)", gender: "Male", value: "ms-MY-OsmanNeural" },
    { name: "Yasmin (Neural)", gender: "Female", value: "ms-MY-YasminNeural" },
  ],
  mlIN: [
    {
      name: "Midhun (Neural) - മിഥുൻ",
      gender: "Male",
      value: "ml-IN-MidhunNeural",
    },
    {
      name: "Sobhana (Neural) - ശോഭന",
      gender: "Female",
      value: "ml-IN-SobhanaNeural",
    },
  ],
  mnMN: [
    { name: "Bataa - Батаа", gender: "Male", value: "mn-MN-BataaNeural" },
    { name: "Yesui - Есүй", gender: "Female", value: "mn-MN-YesuiNeural" },
  ],
  mtMT: [
    { name: "Grace (Neural)", gender: "Female", value: "mt-MT-GraceNeural" },
    { name: "Joseph (Neural)", gender: "Male", value: "mt-MT-JosephNeural" },
  ],
  mrIN: [
    {
      name: "Aarohi (Neural) - आरोही",
      gender: "Female",
      value: "mr-IN-AarohiNeural",
    },
    {
      name: "Manohar (Neural) - मनोहर",
      gender: "Male",
      value: "mr-IN-ManoharNeural",
    },
  ],
  neNP: [
    {
      name: "Hemkala - हेमकला",
      gender: "Female",
      value: "ne-NP-HemkalaNeural",
    },
    { name: "Sagar - सागर", gender: "Male", value: "ne-NP-SagarNeural" },
  ],
  nbNO: [
    {
      name: "Pernille (Neural)",
      gender: "Female",
      value: "nb-NO-PernilleNeural",
    },
    { name: "Finn (Neural)", gender: "Male", value: "nb-NO-FinnNeural" },
    { name: "Iselin (Neural)", gender: "Female", value: "nb-NO-IselinNeural" },
  ],
  psAF: [
    {
      name: "Gul Nawaz (Neural) -  ګل نواز",
      gender: "Male",
      value: "ps-AF-GulNawazNeural",
    },
    {
      name: "Latifa (Neural) - لطيفه",
      gender: "Female",
      value: "ps-AF-LatifaNeural",
    },
  ],
  faIR: [
    {
      name: "Dilara (Neural) - دلارا",
      gender: "Female",
      value: "fa-IR-DilaraNeural",
    },
    {
      name: "Farid (Neural) - فرید",
      gender: "Male",
      value: "fa-IR-FaridNeural",
    },
  ],
  plPL: [
    {
      name: "Agnieszka (Neural)",
      gender: "Female",
      value: "pl-PL-AgnieszkaNeural",
    },
    { name: "Marek (Neural)", gender: "Male", value: "pl-PL-MarekNeural" },
    { name: "Zofia (Neural)", gender: "Female", value: "pl-PL-ZofiaNeural" },
  ],
  ptBR: [
    { name: "Francisca", gender: "Female", value: "pt-BR-FranciscaNeural" },
    { name: "Brenda", gender: "Female", value: "pt-BR-BrendaNeural" },
    { name: "Elza", gender: "Female", value: "pt-BR-ElzaNeural" },
    { name: "Giovanna", gender: "Female", value: "pt-BR-GiovannaNeural" },
    { name: "Lella", gender: "Female", value: "pt-BR-LellaNeural" },
    { name: "Leticia", gender: "Female", value: "pt-BR-LeticiaNeural" },
    { name: "Manuela", gender: "Female", value: "pt-BR-ManuelaNeural" },
    { name: "Yara", gender: "Female", value: "pt-BR-YaraNeural" },
    { name: "Antonio - Antônio", gender: "Male", value: "pt-BR-AntonioNeural" },
    { name: "Donato", gender: "Male", value: "pt-BR-DonatoNeural" },
    { name: "Fabio", gender: "Male", value: "pt-BR-FabioNeural" },
    { name: "Humberto", gender: "Male", value: "pt-BR-HumbertoNeural" },
    { name: "Julio", gender: "Male", value: "pt-BR-JulioNeural" },
    { name: "Nicolau", gender: "Male", value: "pt-BR-NicolauNeural" },
    { name: "Valerio", gender: "Male", value: "pt-BR-ValerioNeural" },
  ],
  ptPT: [
    { name: "Duarte (Neural)", gender: "Male", value: "pt-PT-DuarteNeural" },
    {
      name: "Fernanda (Neural)",
      gender: "Female",
      value: "pt-PT-FernandaNeural",
    },
    { name: "Raquel (Neural)", gender: "Female", value: "pt-PT-RaquelNeural" },
  ],
  roRO: [
    { name: "Alina (Neural)", gender: "Female", value: "ro-RO-AlinaNeural" },
    { name: "Emil (Neural)", gender: "Male", value: "ro-RO-EmilNeural" },
  ],
  ruRU: [
    {
      name: "Svetlana (Neural) - Светлана",
      gender: "Female",
      value: "ru-RU-SvetlanaNeural",
    },
    {
      name: "Dariya (Neural) - Дария",
      gender: "Female",
      value: "ru-RU-DariyaNeural",
    },
    {
      name: "Dmitry (Neural) - Дмитрий",
      gender: "Male",
      value: "ru-RU-DmitryNeural",
    },
  ],
  srRS: [
    {
      name: "Nicholas (Neural) - Никола",
      gender: "Male",
      value: "sr-RS-NicholasNeural",
    },
    {
      name: "Sophie (Neural) - Софија",
      gender: "Female",
      value: "sr-RS-SophieNeural",
    },
  ],
  siLK: [
    {
      name: "Sameera (Neural) - සමීර",
      gender: "Male",
      value: "si-LK-SameeraNeural",
    },
    {
      name: "Thilini (Neural) - තිළිණි",
      gender: "Female",
      value: "si-LK-ThiliniNeural",
    },
  ],
  skSK: [
    {
      name: "Lukas (Neural) - Lukáš",
      gender: "Male",
      value: "sk-SK-LukasNeural",
    },
    {
      name: "Viktoria (Neural) - Viktória",
      gender: "Female",
      value: "sk-SK-ViktoriaNeural",
    },
  ],
  slSI: [
    { name: "Petra (Neural)", gender: "Male", value: "sl-SI-PetraNeural" },
    { name: "Rok (Neural)", gender: "Female", value: "sl-SI-RokNeural" },
  ],
  soSO: [
    { name: "Muuse (Neural)", gender: "Male", value: "so-SO-MuuseNeural" },
    { name: "Ubax (Neural)", gender: "Female", value: "so-SO-UbaxNeural" },
  ],
  esAR: [
    { name: "Elena (Neural)", gender: "Female", value: "es-AR-ElenaNeural" },
    { name: "Tomas (Neural)", gender: "Male", value: "es-AR-TomasNeural" },
  ],
  esBO: [
    { name: "Marcelo (Neural)", gender: "Male", value: "es-BO-MarceloNeural" },
    { name: "Sofia (Neural)", gender: "Female", value: "es-BO-SofiaNeural" },
  ],
  esCL: [
    {
      name: "Catalina (Neural)",
      gender: "Female",
      value: "es-CL-CatalinaNeural",
    },
    { name: "Lorenzo (Neural)", gender: "Male", value: "es-CL-LorenzoNeural" },
  ],
  esCO: [
    { name: "Gonzalo (Neural)", gender: "Male", value: "es-CO-GonzaloNeural" },
    { name: "Salome (Neural)", gender: "Female", value: "es-CO-SalomeNeural" },
  ],
  esCR: [
    { name: "Juan (Neural)", gender: "Male", value: "es-CR-JuanNeural" },
    {
      name: "Maria (Neural) - María",
      gender: "Female",
      value: "es-CR-MariaNeural",
    },
  ],
  esCU: [
    { name: "Belkys (Neural)", gender: "Female", value: "es-CU-BelkysNeural" },
    { name: "Manuel (Neural)", gender: "Male", value: "es-CU-ManuelNeural" },
  ],
  esDO: [
    { name: "Emilio (Neural)", gender: "Male", value: "es-DO-EmilioNeural" },
    { name: "Ramona (Neural)", gender: "Female", value: "es-DO-RamonaNeural" },
  ],
  esEC: [
    { name: "Andrea (Neural)", gender: "Female", value: "es-EC-AndreaNeural" },
    { name: "Luis (Neural)", gender: "Male", value: "es-EC-LuisNeural" },
  ],
  esSV: [
    { name: "Lorena (Neural)", value: "es-SV-LorenaNeural" },
    { name: "Rodrigo (Neural)", value: "es-SV-RodrigoNeural" },
  ],
  esGQ: [
    { name: "Javier (Neural)", gender: "Male", value: "es-GQ-JavierNeural" },
    { name: "Teresa (Neural)", gender: "Female", value: "es-GQ-TeresaNeural" },
  ],
  esGT: [
    {
      name: "Andres (Neural) - Andrés",
      gender: "Male",
      value: "es-GT-AndresNeural",
    },
    { name: "Marta (Neural)", gender: "Female", value: "es-GT-MartaNeural" },
  ],
  esHN: [
    { name: "Carlos (Neural)", gender: "Male", value: "es-HN-CarlosNeural" },
    { name: "Karla (Neural)", gender: "Female", value: "es-HN-KarlaNeural" },
  ],
  esMX: [
    { name: "Beatriz", gender: "Female", value: "es-MX-BeatrizNeural" },
    { name: "Candela", gender: "Female", value: "es-MX-CandelaNeural" },
    { name: "Carlota", gender: "Female", value: "es-MX-CarlotaNeural" },
    { name: "Dalia", gender: "Female", value: "es-MX-DaliaNeural" },
    { name: "Larissa", gender: "Female", value: "es-MX-LarissaNeural" },
    { name: "Marina", gender: "Female", value: "es-MX-MarinaNeural" },
    { name: "Nuria", gender: "Female", value: "es-MX-NuriaNeural" },
    { name: "Nuria", gender: "Female", value: "es-MX-NuriaNeural" },
    { name: "Cecilio", gender: "Male", value: "es-MX-CecilioNeural" },
    { name: "Gerardo", gender: "Male", value: "es-MX-GerardoNeural" },
    { name: "Jorge", gender: "Male", value: "es-MX-JorgeNeural" },
    { name: "Liberto", gender: "Male", value: "es-MX-LibertoNeural" },
    { name: "Luciano", gender: "Male", value: "es-MX-LucianoNeural" },
    { name: "Pelayo", gender: "Male", value: "es-MX-PelayoNeural" },
    { name: "yago", gender: "Male", value: "es-MX-YagoNeural" },
  ],
  esNI: [
    {
      name: "Federico (Neural)",
      gender: "Male",
      value: "es-NI-FedericoNeural",
    },
    {
      name: "Yolanda (Neural)",
      gender: "Female",
      value: "es-NI-YolandaNeural",
    },
  ],
  esPA: [
    {
      name: "Margarita (Neural)",
      gender: "Female",
      value: "es-PA-MargaritaNeural",
    },
    { name: "Roberto (Neural)", gender: "Male", value: "es-PA-RobertoNeural" },
  ],
  esPY: [
    { name: "Mario (Neural)", gender: "Male", value: "es-PY-MarioNeural" },
    { name: "Tania (Neural)", gender: "Female", value: "es-PY-TaniaNeural" },
  ],
  esPE: [
    { name: "Alex (Neural)", gender: "Male", value: "es-PE-AlexNeural" },
    { name: "Camila (Neural)", gender: "Female", value: "es-PE-CamilaNeural" },
  ],
  esPR: [
    { name: "Karina (Neural)", gender: "Female", value: "es-PR-KarinaNeural" },
    {
      name: "Victor (Neural) - Víctor",
      gender: "Male",
      value: "es-PR-VictorNeural",
    },
  ],
  esES: [
    { name: "Abril - Abril", gender: "Female", value: "es-ES-AbrilNeural" },
    { name: "Alvaro - Álvaro", gender: "Male", value: "es-ES-AlvaroNeural" },
    {
      name: "Estrella - Estrella",
      gender: "Female",
      value: "es-ES-EstrellaNeural",
    },
    { name: "Irene - Irene", gender: "Female", value: "es-ES-IreneNeural" },
    { name: "Laia - Laia", gender: "Female", value: "es-ES-LaiaNeural" },
    { name: "Lia - Lia", gender: "Female", value: "es-ES-LiaNeural" },
    { name: "Triana - Triana", gender: "Female", value: "es-ES-TrianaNeural" },
    { name: "Vera - Vera", gender: "Female", value: "es-ES-VeraNeural" },
    { name: "Alvaro - Alvaro", gender: "Male", value: "es-ES-AlvaroNeural" },
    { name: "Arnau - Arnau", gender: "Male", value: "es-ES-ArnauNeural" },
    { name: "Dario - Dario", gender: "Male", value: "es-ES-DarioNeural" },
    { name: "Elias - Elias", gender: "Male", value: "es-ES-EliasNeural" },
    { name: "Nil - Nil", gender: "Male", value: "es-ES-NilNeural" },
    { name: "Saul - Saul", gender: "Male", value: "es-ES-SaulNeural" },
    { name: "Teo - Teo", gender: "Male", value: "es-ES-TeoNeural" },
    { name: "Elvira", gender: "Female", value: "es-ES-ElviraNeural" },
  ],
  esUS: [
    { name: "Alonso (Neural)", gender: "Male", value: "es-US-AlonsoNeural" },
    { name: "Paloma (Neural)", gender: "Female", value: "es-US-PalomaNeural" },
  ],
  esUY: [
    { name: "Mateo (Neural)", gender: "Male", value: "es-UY-MateoNeural" },
    {
      name: "Valentina (Neural)",
      gender: "Female",
      value: "es-UY-ValentinaNeural",
    },
  ],
  esVE: [
    { name: "Paola (Neural)", gender: "Female", value: "es-VE-PaolaNeural" },
    {
      name: "Sebastian (Neural) - Sebastián",
      gender: "Male",
      value: "es-VE-SebastianNeural",
    },
  ],
  suID: [
    { name: "Jajang (Neural)", gender: "Male", value: "su-ID-JajangNeural" },
    { name: "Tuti (Neural)", gender: "Female", value: "su-ID-TutiNeural" },
  ],
  swKE: [
    { name: "Rafiki (Neural)", gender: "Male", value: "sw-KE-RafikiNeural" },
    { name: "Zuri (Neural)", gender: "Female", value: "sw-KE-ZuriNeural" },
  ],
  swTZ: [
    { name: "Daudi (Neural)", gender: "Male", value: "sw-TZ-DaudiNeural" },
    { name: "Rehema (Neural)", gender: "Female", value: "sw-TZ-RehemaNeural" },
  ],
  svSE: [
    { name: "Sofie (Neural)", gender: "Female", value: "sv-SE-SofieNeural" },
    {
      name: "Hillevi (Neural)",
      gender: "Female",
      value: "sv-SE-HilleviNeural",
    },
    { name: "Mattias (Neural)", gender: "Male", value: "sv-SE-MattiasNeural" },
  ],
  taIN: [
    {
      name: "Pallavi (Neural) - பல்லவி",
      gender: "Female",
      value: "ta-IN-PallaviNeural",
    },
    {
      name: "Valluvar (Neural) - வள்ளுவர்",
      gender: "Male",
      value: "ta-IN-ValluvarNeural",
    },
  ],
  taMY: [
    { name: "Kani - கனி", gender: "Female", value: "ta-MY-KaniNeural" },
    { name: "Surya - கனி", gender: "Male", value: "ta-MY-SuryaNeural" },
  ],
  taSG: [
    {
      name: "Anbu (Neural) - அன்பு",
      gender: "Male",
      value: "ta-SG-AnbuNeural",
    },
    {
      name: "Venba (Neural) - வெண்பா",
      gender: "Female",
      value: "ta-SG-VenbaNeural",
    },
  ],
  taLK: [
    {
      name: "Kumar (Neural) - குமார்",
      gender: "Male",
      value: "ta-LK-KumarNeural",
    },
    {
      name: "Saranya (Neural) - சரண்யா",
      gender: "Female",
      value: "ta-LK-SaranyaNeural",
    },
  ],
  teIN: [
    {
      name: "Mohan (Neural) - మోహన్",
      gender: "Male",
      value: "te-IN-MohanNeural",
    },
    {
      name: "Shruti (Neural) - శ్రుతి",
      gender: "Female",
      value: "te-IN-ShrutiNeural",
    },
  ],
  thTH: [
    {
      name: "Premwadee (Neural) - เปรมวดี",
      gender: "Female",
      value: "th-TH-PremwadeeNeural",
    },
    {
      name: "Achara (Neural) - อัจฉรา",
      gender: "Female",
      value: "th-TH-AcharaNeural",
    },
    {
      name: "Niwat (Neural) - นิวัฒน์",
      gender: "Male",
      value: "th-TH-NiwatNeural",
    },
  ],
  trTR: [
    { name: "Ahmet (Neural)", gender: "Male", value: "tr-TR-AhmetNeural" },
    { name: "Emel (Neural)", gender: "Female", value: "tr-TR-EmelNeural" },
  ],
  ukUA: [
    {
      name: "Ostap (Neural) - Остап",
      gender: "Male",
      value: "uk-UA-OstapNeural",
    },
    {
      name: "Polina (Neural) - Поліна",
      gender: "Female",
      value: "uk-UA-PolinaNeural",
    },
  ],
  urIN: [
    { name: "Gul (Neural) - گل", gender: "Female", value: "ur-IN-GulNeural" },
    {
      name: "Salman (Neural) - سلمان",
      gender: "Male",
      value: "ur-IN-SalmanNeural",
    },
  ],
  urPK: [
    { name: "Asad (Neural) - اسد", gender: "Male", value: "ur-PK-AsadNeural" },
    {
      name: "Uzma (Neural) - عظمیٰ",
      gender: "Female",
      value: "ur-PK-UzmaNeural",
    },
  ],
  uzUZ: [
    { name: "Madina (Neural)", gender: "Female", value: "uz-UZ-MadinaNeural" },
    { name: "Sardor (Neural)", gender: "Male", value: "uz-UZ-SardorNeural" },
  ],
  viVN: [
    {
      name: "HoaiMy (Neural) - Hoài My",
      gender: "Female",
      value: "vi-VN-HoaiMyNeural",
    },
    {
      name: "NamMinh (Neural) - Nam Minh",
      gender: "Male",
      value: "vi-VN-NamMinhNeural",
    },
  ],
  cyGB: [
    { name: "Aled (Neural)", gender: "Male", value: "cy-GB-AledNeural" },
    { name: "Nia (Neural)", gender: "Female", value: "cy-GB-NiaNeural" },
  ],
  zuZA: [
    { name: "Thando (Neural)", gender: "Female", value: "zu-ZA-ThandoNeural" },
    { name: "Themba (Neural)", gender: "Male", value: "zu-ZA-ThembaNeural" },
  ],
};

export const LANGUAGE = [
  { code: "af", name: "Afrikaans" },
  { code: "am", name: "አማርኛ (Amharic)" },
  { code: "ar", name: "العربية (Arabic)" },
  { code: "as", name: "অসমীয়া (Assamese)" },
  { code: "az", name: "Azərbaycan dili (Azerbaijani)" },
  { code: "ba", name: "Башҡорт (Bashkir)" },
  { code: "be", name: "беларуская (Belarusian)" },
  { code: "bg", name: "български (Bulgarian)" },
  { code: "bn", name: "বাংলা (Bengali)" },
  { code: "bo", name: "བོད་སྐད་ (Tibetan)" },
  { code: "br", name: "brezhoneg (Breton)" },
  { code: "bs", name: "bosanski (Bosnian)" },
  { code: "ca", name: "català (Catalan)" },
  { code: "cs", name: "čeština (Czech)" },
  { code: "cy", name: "Cymraeg (Welsh)" },
  { code: "da", name: "dansk (Danish)" },
  { code: "de", name: "Deutsch (German)" },
  { code: "el", name: "ελληνικά (Greek)" },
  { code: "en", name: "English" },
  { code: "es", name: "español (Spanish)" },
  { code: "et", name: "eesti (Estonian)" },
  { code: "eu", name: "euskara (Basque)" },
  { code: "fa", name: "فارسی (Persian)" },
  { code: "fi", name: "suomi (Finnish)" },
  { code: "fo", name: "føroyskt (Faroese)" },
  { code: "fr", name: "français (French)" },
  { code: "gl", name: "galego (Galician)" },
  { code: "gu", name: "ગુજરાતી (Gujarati)" },
  { code: "ha", name: "Hausa" },
  { code: "haw", name: "ʻŌlelo Hawaiʻi (Hawaiian)" },
  { code: "he", name: "עברית (Hebrew)" },
  { code: "hi", name: "हिन्दी (Hindi)" },
  { code: "hr", name: "hrvatski (Croatian)" },
  { code: "ht", name: "Kreyòl ayisyen (Haitian Creole)" },
  { code: "hu", name: "magyar (Hungarian)" },
  { code: "hy", name: "հայերեն (Armenian)" },
  { code: "id", name: "Bahasa Indonesia (Indonesian)" },
  { code: "is", name: "íslenska (Icelandic)" },
  { code: "it", name: "italiano (Italian)" },
  { code: "ja", name: "日本語 (Japanese)" },
  { code: "jw", name: "ꦧꦱꦗꦮ (Javanese)" },
  { code: "ka", name: "ქართული (Georgian)" },
  { code: "kk", name: "қазақ тілі (Kazakh)" },
  { code: "km", name: "ភាសាខ្មែរ (Khmer)" },
  { code: "kn", name: "ಕನ್ನಡ (Kannada)" },
  { code: "ko", name: "한국어 (Korean)" },
  { code: "la", name: "Latina (Latin)" },
  { code: "lb", name: "Lëtzebuergesch (Luxembourgish)" },
  { code: "ln", name: "Lingála (Lingala)" },
  { code: "lo", name: "ພາສາລາວ (Lao)" },
  { code: "lt", name: "lietuvių (Lithuanian)" },
  { code: "lv", name: "latviešu (Latvian)" },
  { code: "mg", name: "Malagasy" },
  { code: "mi", name: "Māori" },
  { code: "mk", name: "македонски (Macedonian)" },
  { code: "ml", name: "മലയാളം (Malayalam)" },
  { code: "mn", name: "Монгол (Mongolian)" },
  { code: "mr", name: "मराठी (Marathi)" },
  { code: "ms", name: "Bahasa Melayu (Malay)" },
  { code: "mt", name: "Malti (Maltese)" },
  { code: "my", name: "မြန်မာစာ (Burmese)" },
  { code: "ne", name: "नेपाली (Nepali)" },
  { code: "nl", name: "Nederlands (Dutch)" },
  { code: "nn", name: "nynorsk (Nynorsk)" },
  { code: "no", name: "norsk (Norwegian)" },
  { code: "oc", name: "occitan (Occitan)" },
  { code: "pa", name: "ਪੰਜਾਬੀ (Punjabi)" },
  { code: "pl", name: "polski (Polish)" },
  { code: "ps", name: "پښتو (Pashto)" },
  { code: "pt", name: "português (Portuguese)" },
  { code: "ro", name: "română (Romanian)" },
  { code: "ru", name: "русский (Russian)" },
  { code: "sa", name: "संस्कृतम् (Sanskrit)" },
  { code: "sd", name: "سنڌي (Sindhi)" },
  { code: "si", name: "සිංහල (Sinhala)" },
  { code: "sk", name: "slovenčina (Slovak)" },
  { code: "sl", name: "slovenščina (Slovenian)" },
  { code: "sn", name: "chiShona (Shona)" },
  { code: "so", name: "Soomaali (Somali)" },
  { code: "sq", name: "shqip (Albanian)" },
  { code: "sr", name: "српски (Serbian)" },
  { code: "su", name: "Basa Sunda (Sundanese)" },
  { code: "sv", name: "svenska (Swedish)" },
  { code: "sw", name: "Kiswahili (Swahili)" },
  { code: "ta", name: "தமிழ் (Tamil)" },
  { code: "te", name: "తెలుగు (Telugu)" },
  { code: "tg", name: "тоҷикӣ (Tajik)" },
  { code: "th", name: "ไทย (Thai)" },
  { code: "tk", name: "Türkmen (Turkmen)" },
  { code: "tl", name: "Filipino (Tagalog)" },
  { code: "tr", name: "Türkçe (Turkish)" },
  { code: "tt", name: "татарча (Tatar)" },
  { code: "uk", name: "українська (Ukrainian)" },
  { code: "ur", name: "اردو (Urdu)" },
  { code: "uz", name: "o‘zbekcha (Uzbek)" },
  { code: "vi", name: "Tiếng Việt (Vietnamese)" },
  { code: "yi", name: "ייִדיש (Yiddish)" },
  { code: "yo", name: "Yorùbá (Yoruba)" },
  { code: "zh", name: "中文 (Chinese)" },
  { code: "yue", name: "粵語 (Cantonese)" },
];

export const getLanguageFromValue = (val = "en-US") => {
  return LANGUAGE_DATA.find((l) => l.value === val) || null;
};

export const getVoiceFromValue = (val = "en-US-BrandonNeural") => {
  const voice = LANGUAGE_VOICES.find((voice) => voice.id === val);

  return voice || null;
};

export const getLanguageAndVoiceFromVal = (val = "en-US-BrandonNeural") => {
  // Get the language data
  const languageData = getLanguageFromValue(val.slice(0, 5));

  // Get the voice data
  const voiceData = getVoiceFromValue(val);

  // Combine the results
  return { languageData, voiceData };
};

export const getVoicesOfLanguage = (val = "en-US") => {
  return LANGUAGE_VOICES.filter((v) => v.locale === val);
};

export const styleData = [
  { name: "Default", value: "Default" },
  { name: "Assistant", value: "Assistant" },
  { name: "Chat", value: "Chat" },
  { name: "Customer Service", value: "Customer Service" },
  { name: "Newscast", value: "Newscast" },
  { name: "Excited", value: "Excited" },
  { name: "Narration-professional", value: "Narration-professional" },
  { name: "newscast-casual", value: "newscast-casual" },
  { name: "newcast-formal", value: "newcast-formal" },
  { name: "Affectionate", value: "Affectionate" },
  { name: "empathetic", value: "empathetic" },
  { name: "Angry", value: "Angry" },
  { name: "Calm", value: "Calm" },
  { name: "Friendly", value: "Friendly" },
  { name: "Unfriendly", value: "Unfriendly" },
  { name: "Hopeful", value: "Hopeful" },
  { name: "Terrified", value: "Terrified" },
  { name: "Whispering", value: "Whispering" },
  { name: "Shouting", value: "Shouting" },
  { name: "Cheerful", value: "Cheerful" },
  { name: "Disgruntled", value: "Disgruntled" },
  { name: "Fearful", value: "Fearful" },
  { name: "Gentle", value: "Gentle" },
  { name: "Lyrical", value: "Lyrical" },
  { name: "Sad", value: "Sad" },
  { name: "Serious", value: "Serious" },
  { name: "Poetry - reading", value: "Poetry - reading" },
];

export const zhCNXiaoxiaoNeuralData = [
  { name: "Default", value: "Default" },
  { name: "Assistant", value: "Assistant" },
  { name: "Chat", value: "Chat" },
  { name: "Customer Service", value: "Customer Service" },
  { name: "Newscast", value: "Newscast" },
  { name: "Affectionate", value: "Affectionate" },
  { name: "Angry", value: "Angry" },
  { name: "Calm", value: "Calm" },
  { name: "Cheerful", value: "Cheerful" },
  { name: "Disgruntled", value: "Disgruntled" },
  { name: "Fearful", value: "Fearful" },
  { name: "Gentle", value: "Gentle" },
  { name: "Lyrical", value: "Lyrical" },
  { name: "Sad", value: "Sad" },
  { name: "Serious", value: "Serious" },
  { name: "Poetry - reading", value: "Poetry - reading" },
];
export const zhCNYunyangNeuralData = [
  { name: "Default", value: "Default" },
  { name: "Customer service", value: "Customer service" },
  { name: "Narration - professional", value: "Narration - professional" },
  { name: "Newscast - casual", value: "Newscast - casual" },
];

export const zhCNXiaomoNeuralData = [
  { name: "Default", value: "Default" },
  { name: "Depressed", value: "Depressed" },
  { name: "Calm", value: "Calm" },
  { name: "Fearful", value: "Fearful" },
  { name: "Embarrassed", value: "Embarrassed" },
  { name: "Angry", value: "Angry" },
  { name: "Cheerful", value: "Cheerful" },
  { name: "Disgruntled", value: "Disgruntled" },
  { name: "Sad", value: "Sad" },
  { name: "Serious", value: "Serious" },
  { name: "Affectionate", value: "Affectionate" },
  { name: "Gentle", value: "Gentle" },
  { name: "Envious", value: "Envious" },
  { name: "Serious", value: "Serious" },
];

export const zhCNXiaohanNeuralData = [
  { name: "Default", value: "Default" },
  { name: "Embarrassed", value: "Embarrassed" },
  { name: "Sad", value: "Sad" },
  { name: "Affectionate", value: "Affectionate" },
  { name: "Calm", value: "Calm" },
  { name: "Fearful", value: "Fearful" },
  { name: "Angry", value: "Angry" },
  { name: "Cheerful", value: "Cheerful" },
  { name: "Disgruntled", value: "Disgruntled" },
  { name: "Serious", value: "Serious" },
  { name: "Gentle", value: "Gentle" },
];

export const enGBRyanNeuralData = [
  { name: "Default", value: "Default" },
  { name: "Cheerful", value: "Cheerful" },
  { name: "Chat", value: "Chat" },
];

export const enGBSoniaNeuralData = [
  { name: "Default", value: "Default" },
  { name: "Cheerful", value: "Cheerful" },
  { name: "Sad", value: "Sad" },
];

export const enUSJennyNeuralData = [
  { name: "Default", value: "Default" },
  { name: "Assistant", value: "Assistant" },
  { name: "Chat", value: "Chat" },
  { name: "Customer service", value: "Customer service" },
  { name: "Newscast", value: "Newscast" },
  { name: "Angry", value: "Angry" },
  { name: "Cheerful", value: "Cheerful" },
  { name: "Sad", value: "Sad" },
  { name: "Excited", value: "Excited" },
  { name: "Friendly", value: "Friendly" },
  { name: "Terrified", value: "Terrified" },
  { name: "Shouting", value: "Shouting" },
  { name: "Unfriendly", value: "Unfriendly" },
  { name: "Whispering", value: "Whispering" },
  { name: "Hopeful", value: "Hopeful" },
];

export const enUSDavisNeuralData = [
  { name: "Default", value: "Default" },
  { name: "Chat", value: "Chat" },
  { name: "Angry", value: "Angry" },
  { name: "Cheerful", value: "Cheerful" },
  { name: "Excited", value: "Excited" },
  { name: "Friendly", value: "Friendly" },
  { name: "Hopeful", value: "Hopeful" },
  { name: "Sad", value: "Sad" },
  { name: "Shouting", value: "Shouting" },
  { name: "Terrified", value: "Terrified" },
  { name: "Unfriendly", value: "Unfriendly" },
  { name: "Whispering", value: "Whispering" },
];

export const enUSGuyNeuralData = [
  { name: "Default", value: "Default" },
  { name: "Newscast", value: "Newscast" },
  { name: "Angry", value: "Angry" },
  { name: "Cheerful", value: "Cheerful" },
  { name: "Sad", value: "Sad" },
  { name: "Excited", value: "Excited" },
  { name: "Friendly", value: "Friendly" },
  { name: "Terrified", value: "Terrified" },
  { name: "Shouting", value: "Shouting" },
  { name: "Unfriendly", value: "Unfriendly" },
  { name: "Whispering", value: "Whispering" },
  { name: "Hopeful", value: "Hopeful" },
];
export const enUSSaraNeuralData = [
  { name: "Default", value: "Default" },
  { name: "Angry", value: "Angry" },
  { name: "Cheerful", value: "Cheerful" },
  { name: "Excited", value: "Excited" },
  { name: "Friendly", value: "Friendly" },
  { name: "Hopeful", value: "Hopeful" },
  { name: "Sad", value: "Sad" },
  { name: "Shouting", value: "Shouting" },
  { name: "Terrified", value: "Terrified" },
  { name: "Unfriendly", value: "Unfriendly" },
  { name: "Whispering", value: "Whispering" },
];
export const enUSNancyNeuralData = [
  { name: "Default", value: "Default" },
  { name: "Angry", value: "Angry" },
  { name: "Cheerful", value: "Cheerful" },
  { name: "Excited", value: "Excited" },
  { name: "Friendly", value: "Friendly" },
  { name: "Hopeful", value: "Hopeful" },
  { name: "Sad", value: "Sad" },
  { name: "Shouting", value: "Shouting" },
  { name: "Terrified", value: "Terrified" },
  { name: "Unfriendly", value: "Unfriendly" },
  { name: "Whispering", value: "Whispering" },
];
export const enUSJasonNeuralData = [
  { name: "Default", value: "Default" },
  { name: "Angry", value: "Angry" },
  { name: "Cheerful", value: "Cheerful" },
  { name: "Excited", value: "Excited" },
  { name: "Friendly", value: "Friendly" },
  { name: "Hopeful", value: "Hopeful" },
  { name: "Sad", value: "Sad" },
  { name: "Shouting", value: "Shouting" },
  { name: "Terrified", value: "Terrified" },
  { name: "Unfriendly", value: "Unfriendly" },
  { name: "Whispering", value: "Whispering" },
];
export const enUSJaneNeuralData = [
  { name: "Default", value: "Default" },
  { name: "Angry", value: "Angry" },
  { name: "Cheerful", value: "Cheerful" },
  { name: "Excited", value: "Excited" },
  { name: "Friendly", value: "Friendly" },
  { name: "Hopeful", value: "Hopeful" },
  { name: "Sad", value: "Sad" },
  { name: "Shouting", value: "Shouting" },
  { name: "Terrified", value: "Terrified" },
  { name: "Unfriendly", value: "Unfriendly" },
  { name: "Whispering", value: "Whispering" },
];

export const enUSAriaNeuralData = [
  { name: "Default", value: "Default" },
  { name: "Chat", value: "Chat" },
  { name: "Customer service", value: "Customer service" },
  { name: "Narration - professional", value: "Narration - professional" },
  { name: "Newscast - casual", value: "Newscast - casual" },
  { name: "Newscast - formal", value: "Newscast - formal" },
  { name: "Empathetic", value: "Empathetic" },
  { name: "Angry", value: "Angry" },
  { name: "Cheerful", value: "Cheerful" },
  { name: "Sad", value: "Sad" },
  { name: "Excited", value: "Excited" },
  { name: "Friendly", value: "Friendly" },
  { name: "Terrified", value: "Terrified" },
  { name: "Shouting", value: "Shouting" },
  { name: "Unfriendly", value: "Unfriendly" },
  { name: "Whispering", value: "Whispering" },
  { name: "Hopeful", value: "Hopeful" },
];

export const frFRDeniseNeuralData = [
  { name: "Default", value: "Default" },
  { name: "Cheerful", value: "Cheerful" },
  { name: "Sad", value: "Sad" },
];

export const frFRHenriNeuralData = [
  { name: "Default", value: "Default" },
  { name: "Cheerful", value: "Cheerful" },
  { name: "Sad", value: "Sad" },
];

export const itITIsabellaNeuralData = [
  { name: "Default", value: "Default" },
  { name: "Cheerful", value: "Cheerful" },
  { name: "Chat", value: "Chat" },
];

export const getSpeakers = (lang) => {};

export const getAIVocies = [
  {
    name: "alloy",
    value: "alloy",
  },
  {
    name: "echo",
    value: "echo",
  },
  {
    name: "fable",
    value: "fable",
  },
  {
    name: "onyx",
    value: "onyx",
  },
  {
    name: "nova",
    value: "nova",
  },
  {
    name: "shimmer",
    value: "shimmer",
  },
];
